export default {
  gaAction: 'app download',
  smallHeadingText: 'savings on the go',
  headingText: 'Exclusive Tonight Only Deals. Only in the App.',
  contentText1: 'Discover hotel, flight and rental car deals ',
  contentText2: 'exclusively in the app. ',
  contentText3:
    'Download today to stay connected with important trip details \u2014 anytime, anywhere.',
  image: '/home/public/assets/images/promos/devices.jpg',
  imageWebP: '/home/public/assets/images/promos/devices.webp',
  imageSize: '307px 383px',
  buttons: [
    {
      gaLabel: 'Android',
      linkUrl: 'https://www.priceline.com/mobile-app/'
    },
    {
      gaLabel: 'iOS',
      linkUrl: 'https://www.priceline.com/mobile-app/'
    }
  ]
}
